module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', _vm._g({
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: _vm.containerClass,
    attrs: {
      "type": "button"
    }
  }, _vm.$listeners), [_c('span', {
    staticClass: "p-paginator-icon pi pi-angle-left"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ade668"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/paginator/PrevPageLink.vue
// module id = 2179
// module chunks = 0